import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";
import configApp from "../../config/config-app";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const getOrganizationType = async (values) => {
        if (profileFilter.organization_type) {
            return profileFilter.organization_type;
        }
        const companyId = values?.gci_company_id;
        if (!companyId) return 'default';
        const company = await Fetch.post(`${config.endpoints.backend}gci/companies/getById`, { id: companyId });
        console.log('company', company)
        return company?.organization_type || 'default';
    };

    const getDocumentNumberRequired = async (values) => {
        const documentTypeId = values?.gci_revenue_document_type_id;
        if (!documentTypeId) return true;
        const documentType = await Fetch.post(`${config.endpoints.backend}gci/revenues-document-types/getById`, { id: documentTypeId });
        return documentType?.need_document_number === '1';
    };

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/revenues/save`,
        endpointGetAllAccountingPlans: `${endpointBackend}gci/accounting-plans/getall`,
        endpointGetAllPaymentMethods: `${endpointBackend}gci/payment-methods/getall`,
        endpointGetAllBankAccounts: `${endpointBackend}gci/bank-accounts/getall`,
        endpointGetAllSales: `${endpointBackend}gci/sales/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetAllVentures: `${endpointBackend}gci/ventures/getall`,
        endpointGetAllProjects: `${endpointBackend}gci/projects/getall`,
        endpointGetAllDocumentTypes: `${endpointBackend}gci/revenues-document-types/getall`,
        endpointGetByIdDocumentType: `${endpointBackend}gci/revenues-document-types/getById`,
        endpointGetAllRevenueTypes: `${endpointBackend}gci/revenue-types/getall`,
        endpointGetById: `${endpointBackend}gci/revenues/getById`,
        urlGoBack: `/gci/revenues/list`,
        pathView: `/gci/revenues/view`
    }

    const labels = {
        labelTitleAdd: "Nova Receita",
        labelTitleEdit: "Editar Receita",
        labelTitleView: 'Visualizar Receita'
    }

    const getForm = (values, organizationType = 'default', documentNumberRequired = true) => {
        const isDefaultOrganizationType = organizationType === 'default';
        // Receita de contrato de prestação de serviços não possui empreendimento/projeto
        const isServiceContractRevenue = values?.gci_revenue_type_id === configApp.default_foreign_key.gci_revenue_types.service_contract_revenue;

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        const organizationType = await getOrganizationType(values);
                        const documentNumberRequired = await getDocumentNumberRequired(values);
                        const form = getForm(values, organizationType, documentNumberRequired);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                isServiceContractRevenue ? {} : isDefaultOrganizationType ? {
                    name: 'gci_venture_id',
                    type: 'select',
                    label: 'Empreendimento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllVentures,
                        label: 'enterprise_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        values.gci_bank_account_id = null;
                        const organizationType = await getOrganizationType(values);
                        const documentNumberRequired = await getDocumentNumberRequired(values);
                        const form = getForm(values, organizationType, documentNumberRequired);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                } : {
                    name: 'gci_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        values.gci_bank_account_id = null;
                        const organizationType = await getOrganizationType(values);
                        const documentNumberRequired = await getDocumentNumberRequired(values);
                        const form = getForm(values, organizationType, documentNumberRequired);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    }
                },
                {
                    name: 'gci_revenue_type_id',
                    type: 'select',
                    label: 'Tipo de Receita',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllRevenueTypes,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        if (values.gci_revenue_type_id === configApp.default_foreign_key.gci_revenue_types.service_contract_revenue) {
                            values.gci_venture_id = null;
                            values.gci_project_id = null;
                        }
                        const organizationType = await getOrganizationType(values);
                        const documentNumberRequired = await getDocumentNumberRequired(values);
                        const form = getForm(values, organizationType, documentNumberRequired);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 4
                },
                ,
                {
                    name: 'gci_revenue_document_type_id',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDocumentTypes,
                        label: 'name',
                        value: 'id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 4,
                    handleChange: async (element, field, values) => {
                        const organizationType = await getOrganizationType(values);
                        const documentNumberRequired = await getDocumentNumberRequired(values);
                        const form = getForm(values, organizationType, documentNumberRequired);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    }
                },
                {
                    name: 'document_number',
                    type: 'text',
                    label: 'Número do Documento',
                    validations: {
                        required: documentNumberRequired
                    },
                    columnSize: 4
                },
                {
                    name: 'gci_accounting_plan_id',
                    type: 'select',
                    label: 'Plano de Contas',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAccountingPlans,
                        label: 'full_path',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                                onlyLastLevel: true
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'gci_payment_method_id',
                    type: 'select',
                    label: 'Forma de Recebimento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPaymentMethods,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                type: ['revenue', 'both']
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'gci_sale_id',
                    type: 'select',
                    label: 'Venda Referente (se houver)',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllSales,
                        label: 'sale_resume',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                                type: 'sale'
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'gci_bank_account_id',
                    type: 'select',
                    label: 'Conta Bancária',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBankAccounts,
                        label: 'full_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_venture_id: values.gci_venture_id || null,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'value',
                    type: 'decimal',
                    label: 'Valor da Receita',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'emission_date',
                    type: 'date',
                    label: 'Data de Emissão',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'due_date',
                    type: 'date',
                    label: 'Data de Vencimento',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                id ? {
                    name: 'formattedStatus',
                    type: 'text',
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {}
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            } else {
                values.emission_date = new Date();
                values.due_date = new Date();
            }

            const organizationType = await getOrganizationType(values);
            const documentNumberRequired = await getDocumentNumberRequired(values);

            const form = getForm(values, organizationType, documentNumberRequired);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
